import Cookies from 'js-cookie';
import { notification } from 'antd';
import actions from './actions';
import { DataService } from '../../config/dataService/dataService';

const API_ENDPOINT = `${process.env.REACT_APP_API}/api/v1/iot`;
const {
  getLoad,
  getSuccess,
  getErr,
  addMachineBegin,
  addMachineSuccess,
  addMachineErr,
  getMachineDataLoad,
  getMachineDataSuccess,
  getMachineDataErr,
  getExcelLoad,
  // getExcelSuccess,
  getExcelErr,
} = actions;

const addNotificationSuccess = () => {
  notification.success({
    message: 'Your Record has been Submited',
  });
};

const addNotificationError = (err) => {
  notification.error({
    message: err,
  });
};

const getMachines = () => {
  return async (dispatch) => {
    try {
      await dispatch(getLoad());
      const query = await DataService.get('/machine?enabled=true');
      const token = Cookies.get('access_token');

      if (token) await dispatch(getSuccess(query.data.data));
      else await dispatch(getSuccess([]));
    } catch (err) {
      await dispatch(getErr(err));
    }
  };
};

const createMachine = (data, callback) => {
  return async (dispatch) => {
    try {
      await dispatch(addMachineBegin());

      const response = await DataService.post('/machine', data);
      if (!response.data.success) {
        return;
      }
      await dispatch(addMachineSuccess(response.data.data));
      addNotificationSuccess();
      callback();
    } catch (err) {
      await dispatch(addMachineErr(err));
      addNotificationError(err);
    }
  };
};

const getMachineData = (sQuery, callback) => {
  return async (dispatch) => {
    try {
      await dispatch(getMachineDataLoad());
      const query = await DataService.get(`/ams/processeddata${sQuery}`);
      const token = Cookies.get('access_token');

      if (token) await dispatch(getMachineDataSuccess(query.data.data));
      else await dispatch(getMachineDataSuccess([]));
      callback();
    } catch (err) {
      await dispatch(getMachineDataErr(err));
    }
  };
};

const exportToExcelData = (sQuery, callback) => {
  return async (dispatch) => {
    try {
      await dispatch(getExcelLoad());
      const URL = `${API_ENDPOINT}/ams/xlProcAmsData${sQuery}`;

      window.open(URL);
      // await dispatch(getExcelSuccess(true));
      callback();
    } catch (err) {
      await dispatch(getExcelErr(err));
    }
  };
};
// https://pgiotapi.versamicro.in/api/v1/iot/ams?date=2023-08-02&machineId=KHE-AMS-001

export { getMachines, createMachine, exportToExcelData, getMachineData };
